/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Flex,
  message,
  Card,
  Table,
  DatePicker,
  Typography,
  Space,
  Row,
  Col,
  Modal,
  Select,
  Divider,
} from "antd";
import {
  SearchOutlined,
  SaveFilled,
  PlusCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import {
  componentsEditable,
  columnsDetailsEditable,
  columnsRemarkEditable,
} from "./model";
import { useLocation, useNavigate } from "react-router";
import { delay, formatMoney } from "../../../utils/util";
import dayjs from "dayjs";

import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

import { RiDeleteBin5Line } from "react-icons/ri";

import JobOrderservice from "../../../service/ERP/JobOrder.service";
import OptionService from "../../../service/ERP/Options.service";

import ModalCustomers from "../../../components/modal/ERP/customers/ModalCustomers";

const joservice = JobOrderservice();
const opservice = OptionService();

const gotoFrom = "/ERP/job-order";
const dateFormat = "DD/MM/YYYY";

const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
  version: null,
};

const JobOrderManage = () => {
  const { Text } = Typography;
  const navigate = useNavigate();
  const location = useLocation();
  const { config } = location.state || { config: null };
  const [form] = Form.useForm();

  const [joCode, setJoCode] = useState(null);
  const [prevjoCode, setPrevJoCode] = useState(null);
  const [formDetail, setFormDetail] = useState([]);
  const [parameters_remark, setParameters_remark] = useState([]);
  const [version, setVersion] = useState(0);

  const [detailData, setDetailData] = useState([]);
  const [openModalCustomer, setOpenModalCustomer] = useState(false);

  const [pgnameOption, setPgnameOption] = useState([]);

  useEffect(() => {
    const initeial = async () => {
      if (config?.action === "edit") {
        // console.log(config.code);
        // alert(config.code.jo_id)
        setFormDetail(config.code);
        setJoCode(config.code.jocode);
        setPrevJoCode(config.code.jocode);
        setDetailData(config.code.detail);
        setParameters_remark(config.code.remark || []);
        getpgList(config.code.cuscode);
        setVersion(config.version);

        form.setFieldsValue({
          jodate: config.code.jodate ? dayjs(config.code.jodate) : null,
          cuscode: config.code.cuscode,
          remark: config.code.remark,
          pi_no: config.code.pi_no,
          brand: config.code.brand,
          etl: config.code.etl ? dayjs(config.code.etl) : null,
          etd: config.code.etd ? dayjs(config.code.etd) : null,
          act_etd: config.code.act_etd ? dayjs(config.code.act_etd) : null,
          act_etl: config.code.act_etl ? dayjs(config.code.act_etl) : null,
          shipment: config.code.shipment,
        });
      } else if (config?.action === "copy") {
        // console.log(config.code);
        setVersion(config.version);
        setFormDetail(config.code);
        setJoCode(config.code.jocode);
        setPrevJoCode(config.code.jocode);
        setDetailData(config.code.detail);
        setParameters_remark(config.code.remark || []);
        getpgList(config.code.cuscode);

        form.setFieldsValue({
          jodate: config.code.jodate ? dayjs(config.code.jodate) : null,
          cuscode: config.code.cuscode,
          remark: config.code.remark,
          pi_no: config.code.pi_no,
          brand: config.code.brand,
          etl: config.code.etl ? dayjs(config.code.etl) : null,
          etd: config.code.etd ? dayjs(config.code.etd) : null,
          act_etd: config.code.act_etd ? dayjs(config.code.act_etd) : null,
          act_etl: config.code.act_etl ? dayjs(config.code.act_etl) : null,
          shipment: config.code.shipment,
        });
      } else if (config?.action === "duplicate") {
        const { data: code } = (
          await joservice.code().catch(() => {
            message.error("get Job Order code fail.");
          })
        ).data;
        // alert(code)
        setJoCode(code);
        setPrevJoCode(config.code.jocode);
        const ininteial_value = {
          ...formDetail,
          jocode: code,
          jodate: dayjs(new Date()),
          cuscode: config.code.cuscode,
          cusname: config.code.cusname,
          remark: config.code.remark,
          pi_no: config.code.pi_no,
          brand: config.code.brand,
          etl: config.code.etl ? dayjs(config.code.etl) : null,
          etd: config.code.etd ? dayjs(config.code.etd) : null,
          act_etd: config.code.act_etd ? dayjs(config.code.act_etd) : null,
          act_etl: config.code.act_etl ? dayjs(config.code.act_etl) : null,
          shipment: config.code.shipment,
        };

        form.setFieldsValue(ininteial_value);
        setVersion(0);
        setFormDetail(ininteial_value);
        setDetailData(config.code.detail);
        setParameters_remark(config.code.remark || []);
        getpgList(config.code.cuscode);
      } else {
        const { data: code } = (
          await joservice.code().catch(() => {
            message.error("get Job Order code fail.");
          })
        ).data;
        setJoCode(code);
        const ininteial_value = {
          ...formDetail,
          jocode: code,
          jodate: dayjs(new Date()),
          version: 0,
        };
        setVersion(0);
        setFormDetail(ininteial_value);
        form.setFieldsValue(ininteial_value);
        getpgList("");
      }
    };
    initeial();
  }, [form, config]);

  const handleChoosedCustomer = (value) => {
    const f = form.getFieldValue();
    const prevCuscode = f?.cuscode;
    const initialValues = {
      ...f,
      cuscode: value.cuscode,
      cusname: value.cusname,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);

    // เปลี่ยนลูกค้า = รายการสินค้าเดิมไม่ใช่ของลูกค้ารายใหม่ ต้องล้างทิ้ง
    if (prevCuscode && prevCuscode !== value.cuscode) {
      setDetailData([]);
    }

    getpgList(value.cuscode);
  };

  const handleAddParameter = () => {
    setParameters_remark([
      ...parameters_remark,
      {
        seq: parameters_remark.length + 1,
        remark_detail: null,
      },
    ]);
  };

  const handleBack = async () => {
    if (config?.action === "create") {
      navigate(gotoFrom, { replace: true });
    } else {
      // alert(formDetail.jo_id)
      navigate("/ERP/job-order/view", {
        state: {
          config: {
            ...mngConfig,
            title: "View",
            code: prevjoCode,
            action: "view",
          },
        },
        replace: true,
      });
    }
    await delay(300);
    // console.clear();
  };

  const getpgList = async (cuscode = "") => {
    const [pgOptionRes] = await Promise.all([
      opservice.optionsPG({ p: "jo", cuscode: cuscode }),
    ]);
    setPgnameOption(pgOptionRes.data.data); // TO DO get stcode option
  };

  const handleConfirm = () => {
    // const { data: code } = (
    //       await joservice.code().catch(() => {
    //         message.error("get Job Order code fail.");
    //       })
    //     ).data;

    joservice
      .checkjocode(joCode)
      .then((res) => {
        const {data: r} = res.data;
        
        if (!r|| config?.action === "edit" || config?.action === "copy" ) {
          let errormessage = "";

          form
            .validateFields()
            .then(() => {
              if (detailData.length < 1)
                throw (errormessage = "กรุณาเพิ่มรายการสินค้า");

              if (detailData.some((ld) => !ld.pg_name || ld.pg_name === ""))
                throw (errormessage =
                  "กรุณาเลือกสินค้าที่จะเปิด JO ให้ครบถ้วน");

              const etlValue = form.getFieldValue("etl");
              const etdValue = form.getFieldValue("etd");
              const act_etdValue = form.getFieldValue("act_etd");
              const act_etlValue = form.getFieldValue("act_etl");

              const header = {
                ...formDetail,
                jo_id: formDetail.jo_id,
                jocode: joCode,
                jodate: dayjs(form.getFieldValue("jodate")).format(
                  "YYYY-MM-DD",
                ),
                version: form.getFieldValue("version") || version,
                pi_no: form.getFieldValue("pi_no"),
                brand: form.getFieldValue("brand"),
                etl: etlValue ? dayjs(etlValue).format("YYYY-MM-DD") : null,
                etd: etdValue ? dayjs(etdValue).format("YYYY-MM-DD") : null,
                act_etd: act_etdValue ? dayjs(act_etdValue).format("YYYY-MM-DD") : null,
                act_etl: act_etlValue ? dayjs(act_etlValue).format("YYYY-MM-DD") : null,
                shipment: form.getFieldValue("shipment"),
                remark: form.getFieldValue("remark"),
              };

              const detail = detailData;
              const remark = parameters_remark;
              const parm = { header, detail, remark };
              const actions =
                config?.action === "edit"
                  ? joservice.update(parm)
                  : joservice.create(parm);

              actions
                .then(async () => {
                  message.success("Request success.");
                  navigate(gotoFrom, { replace: true });
                  await delay(300);
                })
                .catch((err) => {
                  const data = err?.response?.data;
                  message.error(data?.message || "บันทึกไม่สำเร็จ");
                });
            })
            .catch(() => {
              if (errormessage === "")
                errormessage = "กรุณาเลือกลูกค้า ก่อนทำการบันทึกข้อมูล";
              message.error(errormessage);
            });
        } else {
          message.error("รหัส " + joCode + " ซ้ำ กรุณาเปลี่ยนรหัสใหม่");
          return;
        }
      })
      .catch(() => {
        message.error("Error: ตรวจสอบรหัส JO ไม่สำเร็จ");
        return;
      });
  };

  const handleSave = (row) => {
    setDetailData((prev) => {
      const idx = prev.findIndex((item) => row.seq === item.seq);
      if (idx < 0) return prev;
      const clone = [...prev];
      clone.splice(idx, 1, { ...clone[idx], ...row });
      return clone;
    });
  };

  const handleSaveRemark = (row) => {
    setParameters_remark((prev) => {
      const idx = prev.findIndex((item) => row.seq === item.seq);
      if (idx < 0) return prev;
      const clone = [...prev];
      clone.splice(idx, 1, { ...clone[idx], ...row });
      return clone;
    });
  };

  const handleDelete = (seq) => {
    setDetailData((prev) =>
      prev.filter((v) => v.seq !== seq).map((v, i) => ({ ...v, seq: i + 1 })),
    );
  };

  const handleAction = (record) =>
    detailData.length >= 1 ? (
      <Button
        className="bt-icon"
        size="small"
        danger
        icon={
          <RiDeleteBin5Line style={{ fontSize: "1rem", marginTop: "3px" }} />
        }
        onClick={() => handleDelete(record?.seq)}
        disabled={!record?.seq}
      />
    ) : null;

  const handleActionRemark = (record) =>
    parameters_remark.length >= 1 ? (
      <Button
        className="bt-icon"
        size="small"
        danger
        icon={
          <RiDeleteBin5Line style={{ fontSize: "1rem", marginTop: "3px" }} />
        }
        onClick={() => {
          setParameters_remark((prev) =>
            prev
              .filter((v) => v.seq !== record.seq)
              .map((v, i) => ({ ...v, seq: i + 1 })),
          );
        }}
      />
    ) : null;

  const handleAddJoDetail = () => {
    setDetailData((prev) => {
      const normalized = prev.map((v, i) => ({ ...v, seq: i + 1 }));
      return [
        ...normalized,
        {
          seq: normalized.length + 1,
          pg_code: null,
          pg_name: null,
          unit_cs: 1,
          carton: 1,
        },
      ];
    });
  };

  const handleModalSelect = (_, row) => {
    form
      .validateFields()
      .then(() => {})
      .catch(() => {
        message.error("กรุณาเลือกลูกค้าก่อน");
      });
  };

  const column = columnsDetailsEditable(
    handleSave,
    handleModalSelect,
    pgnameOption,
    {
      handleAction,
    },
  );

  const column_remark = columnsRemarkEditable(handleSaveRemark, {
    handleActionRemark,
  });

  // dnd-kit setup
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
  );

  const onDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;
    setDetailData((prev) => {
      const oldIndex = prev.findIndex((r) => r.seq === active.id);
      const newIndex = prev.findIndex((r) => r.seq === over.id);
      if (oldIndex < 0 || newIndex < 0) return prev;
      const reordered = arrayMove(prev, oldIndex, newIndex).map((r, i) => ({
        ...r,
        seq: i + 1,
      }));
      return reordered;
    });
  };

  const SectionTop = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <Button
            style={{ width: 120 }}
            icon={<ArrowLeftOutlined />}
            onClick={() => {
              handleBack();
            }}
          >
            กลับ
          </Button>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {/* {formDetail.doc_status === "ยังไม่ได้รับของ" &&
            config?.action !== "create" && (
              <Popconfirm
                placement="topRight"
                title="ยืนยันการยกเลิก"
                description="คุณแน่ใจที่จะยกเลิกJO?"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => handleCancel()}
              >
                <Button
                  className="bn-center justify-center"
                  icon={<CloseCircleFilledIcon style={{ fontSize: "1rem" }} />}
                  type="primary"
                  style={{ width: "9.5rem" }}
                  danger
                >
                  ยกเลิกJO
                </Button>
              </Popconfirm>
            )} */}
          <Button
            className="bn-center justify-center"
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
            // disabled={formDetail.doc_status !== "ยังไม่ได้รับของ"}
          >
            Save
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <Button
            style={{ width: 120 }}
            icon={<ArrowLeftOutlined />}
            onClick={() => {
              handleBack();
            }}
          >
            กลับ
          </Button>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            className="bn-center justify-center"
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
            // disabled={formDetail.doc_status !== "ยังไม่ได้รับของ"}
          >
            Save
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            รายการสินค้า Job Order
          </Typography.Title>
        </Flex>
      </Col>
    </Flex>
  );

  return (
    <div className="product-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
        <Form form={form} layout="vertical" autoComplete="off">
          <Row
            gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
            className="m-0 items-center"
          >
            <Col span={24} style={{ paddingInline: 0 }}>
              {SectionTop}
            </Col>
          </Row>
          <br />
          <Card style={{ backgroundColor: "#f0f0f0" }}>
            <Row
              gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
              className="m-0 items-center"
            >
              <Col xs={24} sm={24} md={17} lg={17} xl={17} xxl={17}>
                <Flex gap={10} align="center" className="justify-start">
                  {config?.action === "create" ||
                  config?.action === "duplicate" ? (
                    <>
                      <Typography.Title level={3} className="m-0">
                        JOB ORDER NO :
                      </Typography.Title>
                      <Form.Item
                        name="jocode"
                        className="!m-0"
                        style={{ width: "8.5rem" }}
                      >
                        <Input
                          className="input-40"
                          placeholder="Enter Order NO"
                          onChange={(e) => {
                            setJoCode(e.target.value);
                            form.setFieldsValue({ jocode: e.target.value });
                          }}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <Typography.Title level={3} className="m-0">
                      JOB ORDER NO : {joCode}
                    </Typography.Title>
                  )}
                </Flex>
              </Col>
              <Col xs={24} sm={24} md={2} lg={2} xl={2} xxl={2}>
                <Flex
                  align="center"
                  className="justify-center md:justify-start lg:justify-start xl:justify-start"
                >
                  <Typography.Title level={3} className="m-0">
                    Version : {version}
                  </Typography.Title>
                </Flex>
              </Col>
              <Col xs={24} sm={24} md={5} lg={5} xl={5} xxl={5}>
                <Flex
                  gap={10}
                  align="center"
                  className="justify-start sm:justify-end"
                >
                  <Typography.Title level={3} className="m-0">
                    JO DATE :
                  </Typography.Title>
                  <Form.Item name="jodate" className="!m-0">
                    <DatePicker
                      className="input-40"
                      allowClear={false}
                      format={dateFormat}
                    />
                  </Form.Item>
                </Flex>
              </Col>
            </Row>
          </Card>
          <br></br>
          <Divider orientation="left" className="!mb-3 !mt-1">
            {" "}
            รายละเอียดหลัก{" "}
          </Divider>
          <Card style={{ backgroundColor: "#f0f0f0" }}>
            <Space
              direction="vertical"
              size="middle"
              style={{ display: "flex", position: "relative" }}
            >
              <Row
                gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                className="m-0"
              >
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Form.Item
                    label="Customer :"
                    name="cuscode"
                    rules={[{ required: true, message: "Please choose data!" }]}
                  >
                    <Space.Compact style={{ width: "100%" }}>
                      <Input
                        readOnly
                        placeholder="Select Customer"
                        value={
                          formDetail.cuscode
                            ? `${formDetail.cuscode} / ${formDetail.cusname}`
                            : ""
                        }
                      />
                      <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        onClick={() => setOpenModalCustomer(true)}
                        style={{ minWidth: 40 }}
                      />
                    </Space.Compact>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Form.Item label="PO ลูกค้า :" name="pi_no">
                    <Input placeholder="Enter Customer PO" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Form.Item label="Brand :" name="brand">
                    <Input placeholder="Enter Brand" />
                  </Form.Item>
                </Col>
              </Row>
              <Row
                gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                className="m-0"
              >
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Form.Item label="ETL :" name="etl">
                    <DatePicker
                      size="large"
                      className="input-40"
                      style={{ width: "100%" }}
                      format={dateFormat}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Form.Item label="ETD :" name="etd">
                    <DatePicker
                      size="large"
                      className="input-40"
                      style={{ width: "100%" }}
                      format={dateFormat}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Form.Item label="Actual ETD :" name="act_etd">
                    <DatePicker
                      size="large"
                      className="input-40"
                      style={{ width: "100%" }}
                      format={dateFormat}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Form.Item label="Actual ETL :" name="act_etl">
                    <DatePicker
                      size="large"
                      className="input-40"
                      style={{ width: "100%" }}
                      format={dateFormat}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Form.Item label="Loading Type :" name="shipment">
                    <Select
                      style={{ height: 40 }}
                      options={[
                        { value: "พาเลต", label: "พาเลต" },
                        { value: "กล่อง", label: "กล่อง" },
                      ]}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Space>
          </Card>

          <Divider orientation="left" className="!mb-3 !mt-1">
            {" "}
            รายการสินค้า{" "}
          </Divider>
          <Card style={{ backgroundColor: "#f0f0f0" }}>
            <Row
              gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
              className="m-0"
            >
              <Col xs={24}>
                <DndContext
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragEnd={onDragEnd}
                >
                  <SortableContext
                    items={detailData.map((r) => r.seq)}
                    strategy={verticalListSortingStrategy}
                  >
                    <Table
                      title={() => TitleTable}
                      components={componentsEditable}
                      rowClassName={() => "editable-row"}
                      bordered
                      dataSource={detailData || []}
                      columns={column}
                      pagination={false}
                      rowKey="seq"
                      scroll={{ x: "max-content" }}
                      size="small"
                      locale={{
                        emptyText: (
                          <span>No data available, please add some data.</span>
                        ),
                      }}
                      summary={(v) => (
                        <>
                          {detailData.length > 0 && (
                            <Table.Summary.Row>
                              <Table.Summary.Cell
                                index={0}
                                colSpan={5}
                                align="right"
                              >
                                รวม
                              </Table.Summary.Cell>
                              <Table.Summary.Cell
                                index={1}
                                className="text-summary text-end border-right-0 pe-summary"
                              >
                                <Text type="danger">
                                  {formatMoney(
                                    v.reduce(
                                      (a, x) => (a += Number(x?.carton || 0)),
                                      0,
                                    ) || 0,
                                  )}
                                </Text>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell
                                index={1}
                                colSpan={2}
                                className="text-summary text-end border-right-0 pe-summary"
                              >
                                <Text type="danger" className="underline">
                                  {formatMoney(
                                    v.reduce(
                                      (a, x) =>
                                        (a +=
                                          Number(x?.carton || 0) *
                                          Number(x?.unit_cs || 0)),
                                      0,
                                    ) || 0,
                                  )}
                                </Text>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell
                                index={1}
                                colSpan={2}
                                className="text-summary text-end border-right-0 pe-summary"
                              />
                            </Table.Summary.Row>
                          )}
                          <Table.Summary.Row>
                            <Table.Summary.Cell index={1} colSpan={10}>
                              <Row>
                                <Col
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                  className="width-100 append-step"
                                >
                                  <Button
                                    shape="circle"
                                    icon={<PlusCircleOutlined />}
                                    style={{
                                      width: "2.5rem",
                                      boxShadow: "none",
                                      lineHeight: "2.5rem",
                                    }}
                                    onClick={handleAddJoDetail}
                                  />
                                </Col>
                              </Row>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        </>
                      )}
                    />
                  </SortableContext>
                </DndContext>
              </Col>
            </Row>
          </Card>
          <Divider orientation="left" className="!mb-3 !mt-1">
            {" "}
            ข้อมูลเพิ่มเติม{" "}
          </Divider>
          <Card style={{ backgroundColor: "#f0f0f0" }}>
            <Space
              direction="vertical"
              size="middle"
              style={{ display: "flex", position: "relative" }}
              className="sample-request-modal"
            >
              <Table
                title={() => (
                  <Typography.Title className="m-0 !text-zinc-800" level={3}>
                    ข้อกำหนดพิเศษ
                  </Typography.Title>
                )}
                components={componentsEditable}
                rowClassName={() => "editable-row"}
                bordered
                dataSource={parameters_remark || []}
                columns={column_remark}
                pagination={false}
                rowKey="seq"
                locale={{
                  emptyText: (
                    <span>No data available, please add some data.</span>
                  ),
                }}
                scroll={{ x: "max-content" }}
                size="small"
              />
              <Row style={{ paddingInline: 14 }}>
                <Col
                  span={24}
                  style={{ display: "flex", justifyContent: "center" }}
                  className="width-100 append-step"
                >
                  <Button
                    shape="circle"
                    icon={<PlusCircleOutlined />}
                    style={{
                      width: "2.5rem",
                      boxShadow: "none",
                      lineHeight: "2.5rem",
                    }}
                    onClick={() => {
                      handleAddParameter();
                    }}
                  ></Button>
                </Col>
              </Row>
            </Space>
          </Card>

          <Row>
            <Col span={24} style={{ paddingInline: 0 }}>
              {SectionBottom}
            </Col>
          </Row>
        </Form>
      </Space>

      {openModalCustomer && (
        <ModalCustomers
          show={openModalCustomer}
          close={() => setOpenModalCustomer(false)}
          values={handleChoosedCustomer}
        />
      )}

      {/* {openModalProduct && (
        <ModalProduct
          show={openModalProduct}
          close={() => setOpenModalProduct(false)}
          values={handleChooseItems}
          selected={detailData}
          cuscode={form.getFieldValue("cuscode")}
        />
      )} */}
    </div>
  );
};

export default JobOrderManage;
